/**
 * Blog Topic Filter — Artemis Therapeutics
 *
 * Prefetch-on-hover for topic/pillar navigation.
 * No AJAX content swapping — the browser handles URL, history, scroll,
 * and accessibility natively. Prefetching makes the next page load from
 * cache so navigation feels near-instant.
 *
 * How it works:
 * 1. User hovers a topic pill or pillar card → browser prefetches that page
 * 2. User clicks → browser navigates to the (already-cached) page
 * 3. New page fades in via CSS animation (200ms)
 *
 * Degrades gracefully: if JS fails, links work normally.
 */
(function () {
  'use strict';

  var containers = document.querySelectorAll('.blog-topic-nav, .journal-pillars');
  if (!containers.length) return;

  var prefetched = {};

  function prefetchHref(link) {
    if (!link || !link.href || prefetched[link.href]) return;
    // Only prefetch same-origin blog links
    if (link.origin !== window.location.origin) return;
    prefetched[link.href] = true;
    var el = document.createElement('link');
    el.rel = 'prefetch';
    el.href = link.href;
    el.as = 'document';
    document.head.appendChild(el);
  }

  containers.forEach(function (nav) {
    // Prefetch on hover (desktop)
    nav.addEventListener('mouseover', function (e) {
      prefetchHref(e.target.closest('a'));
    });

    // Prefetch on touchstart (mobile — fires ~300ms before click)
    nav.addEventListener('touchstart', function (e) {
      prefetchHref(e.target.closest('a'));
    }, { passive: true });
  });
})();
